import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core';
import { withRouter } from "react-router-dom";
// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';
import AddProperty from "./components/AddProperty";
// Material table
import MaterialTable from 'material-table'

// Material Kit
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import Button from "components/CustomButtons/Button.jsx";

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// import { cardTitleWhite, cardCategoryWhite } from "assets/jss/material-kit-pro-react.jsx";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class Properties extends Component {

  constructor(props) {
    super(props);
    this.state = {
      AddPropertyModal: false
    };
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleClickDelete(property) {

    window.confirm("You want to delete " + property);

  }

  render() {
    const { classes } = this.props;
    const { confirm } = this.props;

    return (
      <ApplicationLayout title="Properties">
        <div className={classes.root}>
          <Grid
            container
            spacing={8}
          >
            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >

            </Grid>

            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
              <Card plain>
              {/*
                <CardHeader plain color="info">
                  <h4 className={classes.cardTitleWhite}>Properties list</h4>
                  <p className={classes.cardCategoryWhite}>
                    List, search and filter properties
                  </p>
                </CardHeader>
              */}
                <CardBody>

                  <MaterialTable
                  columns={[
                    { title: 'Name', field: 'attributes.name' }, //, render: rowData => <img src={rowData.attributes.avatar} style={{width: 40, borderRadius: '50%'}}/> },
                    { title: 'Id', field: 'id' },
                    { title: 'Description', field: 'attributes.description' },
                    { title: 'Public', field: 'attributes.public', type: 'boolean' },
                    { title: 'Active', field: 'attributes.active', type: 'boolean' },
                    { title: 'Sale price', field: 'attributes.sale_price', type: 'currency' },

                  ]}
                  data={query =>
                      new Promise((resolve, reject) => {
                        let url = `${process.env.REACT_APP_API_URL}properties?`
                        url += 'per_page=' + query.pageSize
                        url += '&page=' + (query.page + 1)
                        url += '&search=' + query.search
                        if (typeof query.orderBy !== 'undefined') {
                          url += '&order_by=' + query.orderBy.field
                          url += '&order_direction=' + query.orderDirection
                        }


                        console.log(query);

                        const headers = {
                          Accept: "application/json",
                          "Content-Type": "application/json"
                        };

                        headers["Authorization"] = "Bearer " + confirm;

                        fetch(url, {
                          headers
                        })
                          .then(response => response.json())
                          .then(result => {
                            resolve({
                              data: result.data,
                              page: result.meta.page - 1,
                              totalCount: result.meta.total,
                            })
                          })
                      })
                    }
                  title="Properties"
                  options={{
                    grouping: true,
                    search: true,
                    filtering: true,
                    exportButton: true,
                    actionsColumnIndex: -1
                  }}
                  actions={[
                              {
                                icon: 'forward',
                                tooltip: 'Go to property',
                                onClick: (event, rowData) => this.props.history.push('/properties/' + rowData.id )
                              },
                              rowData => ({
                                icon: 'delete',
                                tooltip: 'Delete property',
                                onClick: (event, rowData) => this.handleClickDelete(rowData.id),
                                disabled: rowData.attributes.active === true
                              }),
                              {
                                icon: 'add',
                                tooltip: 'Add property',
                                isFreeAction: true,
                                onClick: (event) => this.handleClickOpen("AddPropertyModal")
                              }
                            ]}

                />
                </CardBody>
              </Card>
            </Grid>

          </Grid>
        </div>
        <AddProperty handleClose={this.handleClose.bind(this)} isOpen={this.state.AddPropertyModal}/>
      </ApplicationLayout>
    );
  }
}

Properties.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withAuth,
  withStyles(styles),
  withRouter
)(Properties);
